import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { curry } from '../utils/func';
var defaultProps = {
  client: undefined,
  onDragStart: function onDragStart() {},
  onDrag: function onDrag() {},
  onDragEnd: function onDragEnd() {}
};
export default curry(function (OriginComponent) {
  var Drag =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(Drag, _PureComponent);

    var _super = _createSuper2(Drag);

    function Drag(props) {
      var _this;

      _classCallCheck(this, Drag);

      _this = _super.call(this, props);
      _this.clientX = void 0;
      _this.clientY = void 0;
      _this.dragging = void 0;
      _this.handleDragStart = _this.handleDragStart.bind(_assertThisInitialized(_this));
      _this.handleDrag = _this.handleDrag.bind(_assertThisInitialized(_this));
      _this.handleDragEnd = _this.handleDragEnd.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(Drag, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var client = this.props.client;

        if (client) {
          this.clientX = client.x;
          this.clientY = client.y;
          this.dragging = true;
          this.addEvents();
          if (this.props.onDragStart) this.props.onDragStart();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeEvents();
      }
    }, {
      key: "addEvents",
      value: function addEvents() {
        document.addEventListener('mousemove', this.handleDrag);
        document.addEventListener('mouseup', this.handleDragEnd);
        document.addEventListener('mouseleave', this.handleDragEnd);
      }
    }, {
      key: "removeEvents",
      value: function removeEvents() {
        document.removeEventListener('mousemove', this.handleDrag);
        document.removeEventListener('mouseup', this.handleDragEnd);
        document.removeEventListener('mouseleave', this.handleDragEnd);
      }
    }, {
      key: "handleDragStart",
      value: function handleDragStart(e) {
        if (e.button !== 0) return;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        this.dragging = true;
        this.addEvents();
        if (this.props.onDragStart) this.props.onDragStart();
      }
    }, {
      key: "handleDrag",
      value: function handleDrag(e) {
        if (!this.dragging) return;
        if (e.clientX === 0 && e.clientY === 0) return;
        var mx = e.clientX - this.clientX;
        var my = e.clientY - this.clientY;
        if (mx === 0 && my === 0) return;
        this.clientX = e.clientX;
        this.clientY = e.clientY;
        if (this.props.onDrag) this.props.onDrag(mx, my, e.clientX, e.clientY);
      }
    }, {
      key: "handleDragEnd",
      value: function handleDragEnd() {
        if (!this.dragging) return;
        this.dragging = false;
        this.removeEvents();
        if (this.props.onDragEnd) this.props.onDragEnd();
      }
    }, {
      key: "render",
      value: function render() {
        return (
          /*#__PURE__*/
          React.createElement(OriginComponent, Object.assign({}, this.props, {
            onDragStart: this.handleDragStart
          }))
        );
      }
    }]);

    return Drag;
  }(PureComponent);

  Drag.defaultProps = defaultProps;
  return Drag;
});